import { render } from "./DevolucionesPage.vue?vue&type=template&id=99696b3e&scoped=true"
import script from "./DevolucionesPage.vue?vue&type=script&lang=js"
export * from "./DevolucionesPage.vue?vue&type=script&lang=js"

import "./DevolucionesPage.vue?vue&type=style&index=0&id=99696b3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99696b3e"]])

export default __exports__